import React, { useState, useContext, useEffect } from "react"
import { navigate, Link } from "gatsby"
import SEO from "../components/seo"
import Card from "@material-ui/core/Card"
import CardActions from "@material-ui/core/CardActions"
import CardContent from "@material-ui/core/CardContent"
import CardHeader from "@material-ui/core/CardHeader"
import TextField from "@material-ui/core/TextField"
import Button from "@material-ui/core/Button"
import { FirebaseContext } from "../components/firebase"
import Alert from "@material-ui/lab/Alert"
import Grid from "@material-ui/core/Grid"

const rowStyle = {
  marginBottom: "15px",
}

const LoginPage = () => {
  const [errorMessage, setErrorMessage] = useState(null)
  const [formValues, setFormValues] = useState({
    email: "",
    password: "",
  })

  const { firebase } = useContext(FirebaseContext)
  let isMounted = true

  useEffect(() => {
    return () => {
      isMounted = false
    }
  }, [])

  const handleInputChange = e => {
    e.persist()
    setErrorMessage(null)
    setFormValues(currentValues => ({
      ...currentValues,
      [e.target.name]: e.target.value,
    }))
  }

  const handleFormSubmit = e => {
    e.preventDefault()
    firebase
      .login({
        email: formValues.email,
        password: formValues.password,
      })
      .then(() => navigate("/games"))
      .catch(error => {
        if (isMounted) {
          setErrorMessage(error.message)
        }
      })
  }

  return (
    <section>
      <SEO title="Login" />
      <Grid container justify="center" alignContent="center">
        <Grid item xs={12} sm={6}>
          <Card
            style={{
              padding: "1em",
            }}
            elevation={2}
          >
            <CardHeader title="Login" />
            <form onSubmit={handleFormSubmit}>
              <CardContent>
                <div style={rowStyle}>
                  <TextField
                    name="email"
                    onChange={handleInputChange}
                    value={formValues.email}
                    label="Email"
                    type="email"
                    variant="outlined"
                    fullWidth
                    required
                  />
                </div>
                <div style={rowStyle}>
                  <TextField
                    name="password"
                    onChange={handleInputChange}
                    value={formValues.password}
                    type="password"
                    label="Password"
                    variant="outlined"
                    fullWidth
                    required
                  />
                </div>
                {errorMessage ? (
                  <Alert severity="error">{errorMessage}</Alert>
                ) : null}
              </CardContent>
              <CardActions>
                <Button
                  variant="contained"
                  style={{ backgroundColor: "var(--green)", color: "white" }}
                  type="submit"
                  fullWidth
                  disableElevation
                >
                  Login
                </Button>
              </CardActions>
              <h5
                style={{
                  textAlign: "center",
                  marginTop: "1em",
                }}
              >
                Don't have an account? Register{" "}
                <Link to="/register">Here!</Link>
              </h5>
            </form>
          </Card>
        </Grid>
      </Grid>
    </section>
  )
}

export default LoginPage
